export default __webpack_public_path__ + "static/media/plans-active.f33071c1.png";